import { ModuleContent } from '../contract';

export type AnimatedSvgAnimationBehavior = 'default' | 'playWhenVisible' | 'disabled';

/**
 * Content for inline, sanitized SVG illustrations.
 */
export type AnimatedSvgModuleContent = {
	svgMarkup: string;
	ariaLabel?: string;
	caption?: string;
	animationBehavior?: AnimatedSvgAnimationBehavior;
};

export function isAnimatedSvgModuleContent(content: ModuleContent): content is AnimatedSvgModuleContent {
	return typeof (content as AnimatedSvgModuleContent).svgMarkup === 'string';
}

export function getAnimatedSvgModuleIndexableText(content: ModuleContent): string {
	if (!isAnimatedSvgModuleContent(content)) return '';
	return [content.ariaLabel, content.caption].filter(Boolean).join(' ').trim();
}
